import React, { Component } from "react";
import axios from "axios";
import {
  Card,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Navigate } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

export default class UpdateBlogs extends Component {
  state = {
    loading: false,
    initialLoading: true,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
    blogs_poster: {},
    existingPoster: "",
    blogs_title: "",
    blog_content: "",
    blogs_for: "",
    blog_type: "",
    youtube_video_id: "",
    status: "active",
  };

  componentDidMount() {
    this.getBlogDetails();
  }

  getBlogId = () => {
    return window.location.pathname.split("/").pop();
  };

  getBlogDetails = () => {
    const blogId = this.getBlogId();

    if (init() !== "success") {
      this.setState({ initialLoading: false });
      return;
    }

    axios
      .get(`${Constants.getUrls.getAllBlogs}/${blogId}`)
      .then((resp) => {
        const blog = resp?.data?.data || {};
        this.setState({
          initialLoading: false,
          blogs_title: blog.blogs_title || "",
          blog_content: blog.blog_content || "",
          blogs_for: blog.blogs_for || "",
          blog_type: blog.blog_type || "",
          youtube_video_id: blog.youtube_video_id || "",
          status: blog.status || "active",
          existingPoster: blog.blogs_poster || "",
        });
      })
      .catch((err) => {
        this.setState({
          initialLoading: false,
          notification: true,
          notiColor: "error",
          message: err?.response?.data?.message || "Unable to load blog details.",
        });
      });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleDescription = (blog_content) => {
    this.setState({ blog_content });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const blogId = this.getBlogId();
    const fd = new FormData();

    fd.append("blogs_title", this.state.blogs_title);
    fd.append("blog_content", this.state.blog_content);
    fd.append("blog_type", this.state.blog_type);
    fd.append("blogs_for", this.state.blogs_for);
    fd.append("youtube_video_id", this.state.youtube_video_id);
    fd.append("status", this.state.status);

    if (this.state.blogs_poster?.name) {
      fd.append("blogs_poster", this.state.blogs_poster);
    }

    this.setState({ loading: true });

    axios
      .put(`${Constants.putUrls.updateBlog}${blogId}`, fd)
      .then((resp) => {
        this.setState({
          loading: false,
          notification: true,
          notiColor: "success",
          message: resp?.data?.message || "Blog updated successfully.",
        });

        setTimeout(() => {
          this.setState({
            redirect: true,
            notification: false,
            message: "",
          });
        }, 2000);
      })
      .catch((err) => {
        this.setState({
          loading: false,
          notification: true,
          notiColor: "error",
          message: err?.response?.data?.message || "Unable to update blog.",
        });
      });
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/blogs" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Update Blog
              </MDTypography>
            </MDBox>
            <MDBox py={3} px={2}>
              {this.state.initialLoading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : (
                <form onSubmit={this.handleSubmit}>
                  <Grid container sm={12} spacing={2}>
                    <Grid item sm={6}>
                      <TextField
                        type="text"
                        label="Blog Title"
                        name="blogs_title"
                        value={this.state.blogs_title}
                        onChange={this.handleInput}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <TextField
                        type="file"
                        label="Blogs Poster"
                        name="blogs_poster"
                        focused
                        helperText={
                          this.state.blog_type === "video"
                            ? "Optional for video blogs. YouTube thumbnail will be used in the app."
                            : "Upload a new poster only if you want to replace the existing one."
                        }
                        onChange={(e) => {
                          this.setState({
                            blogs_poster: e.target.files[0],
                          });
                        }}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </Grid>

                    <Grid item sm={6}>
                      <InputLabel>Select Blog Type</InputLabel>
                      <Select
                        value={this.state.blog_type}
                        onChange={(e) => this.setState({ blog_type: e.target.value })}
                        name="blog_type"
                        required
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">Select Blog Type</MenuItem>
                        <MenuItem value="text" style={{ color: "#111" }}>
                          Text
                        </MenuItem>
                        <MenuItem value="video" style={{ color: "#111" }}>
                          Video
                        </MenuItem>
                      </Select>
                    </Grid>

                    <Grid item sm={6}>
                      <InputLabel>Select Blogs For</InputLabel>
                      <Select
                        value={this.state.blogs_for}
                        onChange={(e) => this.setState({ blogs_for: e.target.value })}
                        name="blogs_for"
                        required
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="">Select Destination</MenuItem>
                        <MenuItem value="web" style={{ color: "#111" }}>
                          Web
                        </MenuItem>
                        <MenuItem value="app" style={{ color: "#111" }}>
                          App
                        </MenuItem>
                        <MenuItem value="both" style={{ color: "#111" }}>
                          Both
                        </MenuItem>
                      </Select>
                    </Grid>

                    <Grid item sm={6}>
                      <InputLabel>Visibility Status</InputLabel>
                      <Select
                        value={this.state.status}
                        onChange={(e) => this.setState({ status: e.target.value })}
                        name="status"
                        required
                        style={{ width: "100%", height: "45px", color: "#111" }}
                      >
                        <MenuItem value="active" style={{ color: "#111" }}>
                          Active
                        </MenuItem>
                        <MenuItem value="inactive" style={{ color: "#111" }}>
                          Inactive
                        </MenuItem>
                      </Select>
                    </Grid>

                    {this.state.blog_type === "video" ? (
                      <Grid item sm={6}>
                        <TextField
                          type="text"
                          label="YouTube Video ID"
                          name="youtube_video_id"
                          value={this.state.youtube_video_id}
                          onChange={this.handleInput}
                          helperText="Example: dQw4w9WgXcQ"
                          required
                          style={{ width: "100%", height: "100%" }}
                        />
                      </Grid>
                    ) : null}

                    <Grid item sm={12}>
                      <SunEditor
                        setDefaultStyle="font-family: Arial; font-size: 16px;"
                        setOptions={{
                          buttonList: [
                            ["undo", "redo"],
                            ["font", "fontSize"],
                            ["paragraphStyle", "blockquote"],
                            ["bold", "underline", "italic", "strike", "subscript", "superscript"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list", "lineHeight"],
                            ["outdent", "indent"],
                            ["table", "horizontalRule", "link", "image", "video"],
                            ["imageGallery"],
                            ["preview", "print"],
                            ["removeFormat"],
                          ],
                          defaultTag: "div",
                          height: 120,
                          showPathLabel: false,
                        }}
                        name="blog_content"
                        setContents={this.state.blog_content}
                        onChange={this.handleDescription}
                      />
                    </Grid>
                  </Grid>

                  <Grid align="left" mt={2}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Updating..." : "Update"}
                    </MDButton>
                  </Grid>
                </form>
              )}
            </MDBox>
            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
